/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Story_BankInputs */

const en_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const de_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story-Bank`)
};

const fr_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const es_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const it_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const nl_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const pl_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const fi_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const da_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

const sv_nav_story_bank = /** @type {(inputs: Nav_Story_BankInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Story Bank`)
};

/**
* | output |
* | --- |
* | "Story Bank" |
*
* @param {Nav_Story_BankInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const nav_story_bank = /** @type {((inputs?: Nav_Story_BankInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Story_BankInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nav_story_bank(inputs)
	if (locale === "fr") return fr_nav_story_bank(inputs)
	if (locale === "es") return es_nav_story_bank(inputs)
	if (locale === "it") return it_nav_story_bank(inputs)
	if (locale === "nl") return nl_nav_story_bank(inputs)
	if (locale === "pl") return pl_nav_story_bank(inputs)
	if (locale === "fi") return fi_nav_story_bank(inputs)
	if (locale === "da") return da_nav_story_bank(inputs)
	if (locale === "sv") return sv_nav_story_bank(inputs)
	return en_nav_story_bank(inputs)
});